import { render, staticRenderFns } from "./NewsTabMedia.vue?vue&type=template&id=878b8c20&"
import script from "./NewsTabMedia.vue?vue&type=script&lang=js&"
export * from "./NewsTabMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports